/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import viewModel from '@bingads-webui-static-legacy/shared/viewmodel/doubleListBoxViewModel';
import defaultLayoutTemplate from '@bingads-webui-static-legacy/shared/template/doubleListBox/defaultLayout.pug';
import defaultSourceItemTemplate from '@bingads-webui-static-legacy/shared/template/doubleListBox/defaultSourceItem.pug';
import defaultSelectedItemTemplate from '@bingads-webui-static-legacy/shared/template/doubleListBox/defaultSelectedItem.pug';
import Pager from '@bingads-webui-static-legacy/shared/view/pager';
import '@bingads-webui/kendo/kendo.listview';
import '@bingads-webui/kendo/kendo.draganddrop';
import '@bingads-webui-component-legacy/searchbox/ko/searchboxBinding';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var defaultTemplates = {
  layoutTemplate: defaultLayoutTemplate({
    i18n: i18n
  }),
  sourceContainerSelector: '.dlb-source',
  selectedContainerSelector: '.dlb-selected',
  sourcePagerSelector: '.pager-container',
  selectedPagerSelector: '.pager-selected-container',
  sourceItemLayoutTemplate: defaultSourceItemTemplate({
    i18n: i18n
  }),
  sourceItemContentSelector: '.dlbItem-content',
  sourceItemContentTemplate: '<span>#:data.name#</span>',
  selectedItemLayoutTemplate: defaultSelectedItemTemplate({
    i18n: i18n
  }),
  selectedItemContentSelector: '.dlbItem-content',
  selectedItemContentTemplate: '<span>#:data.name#</span>'
};
var listItemCssClass = 'dlbItem';
var controlView = backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    this.options.data = this.options.data || ({});
    var self = this;
    self._applyDefaultTemplates();
    self.options.features = _.defaults(self.options.features || ({}), {
      filtering: true,
      paging: true,
      selectAll: true,
      deselectAll: true,
      dragAndDrop: true,
      maxSelectedItemsCount: -1
    });
    self.options.strings = _.defaults({}, self.options.strings, {
      filterWatermark: i18n.getString('DoubleListBox_Search')
    });
    self._viewModel = new viewModel(_.pick(self.options, 'data', 'itemActions', 'strings', 'features', 'customData', 'processItem'));
    self.selectItem = _.bind(self._viewModel.selectItem, self._viewModel);
    self.deselectItem = _.bind(self._viewModel.deselectItem, self._viewModel);
    self.refreshItem = _.bind(self._viewModel.refreshItem, self._viewModel);
    self.setSelection = _.bind(self._viewModel.setSelection, self._viewModel);
    self.refreshSource = _.bind(self._viewModel.refreshSource, self._viewModel);
    self.selectedItems = ko.computed({
      read: function () {
        return _.clone(self._viewModel.selectedItems());
      },
      write: function (newSelection) {
        self._viewModel.setSelection(newSelection);
      }
    });
    self.selectedItems.subscribe(function (newSelection) {
      self.trigger('selectionChanged', newSelection);
    });
    this._initializeActions();
    this._initializeEventHandlers();
  },
  render: function () {
    this._initializeLayout();
    this._initializeSource();
    this._initializeSelected();
    if (this.options.features.dragAndDrop) {
      this._initializeDragAndDrop();
    }
    if (this.options.features.paging) {
      this._initializeSourcePager();
      this._initializeSelectedPager();
    }
    return this;
  },
  _initializeLayout: function () {
    var self = this;
    self.$wrapper = $('<div/>').appendTo(self.$el).html(self.options.templates.layoutTemplate);
    ko.applyBindings(self._viewModel, self.$wrapper[0]);
    self.elements = {
      $source: self.$(self.options.templates.sourceContainerSelector),
      $selection: self.$(self.options.templates.selectedContainerSelector)
    };
  },
  _initializeSource: function () {
    var self = this;
    self.elements.$source.kendoListView({
      navigatable: true,
      selectable: true,
      dataSource: self._viewModel.sourceDataSource,
      template: self._getEffectiveItemTemplate(this.options.templates.sourceItemLayoutTemplate, this.options.templates.sourceItemContentTemplate)
    });
  },
  _initializeSelected: function () {
    var self = this;
    self.elements.$selection.kendoListView({
      navigatable: true,
      selectable: true,
      dataSource: self._viewModel.selectedDataSource,
      template: self._getEffectiveItemTemplate(this.options.templates.selectedItemLayoutTemplate, this.options.templates.selectedItemContentTemplate)
    });
  },
  _getEffectiveItemTemplate: function (layoutTemplate, contentTemplate) {
    return layoutTemplate.replace('<!--content-->', contentTemplate);
  },
  _initializeDragAndDrop: function () {
    var self = this;
    self._initializeDragAndDropGroup(self.elements.$source, self.elements.$selection, 'select', self._viewModel.sourceData, self.selectItem, self.options.templates.sourceItemContentSelector);
    self._initializeDragAndDropGroup(self.elements.$selection, self.elements.$source, 'deselect', self._viewModel.selectedData, self.deselectItem, self.options.templates.selectedItemContentSelector);
  },
  _initializeDragAndDropGroup: function ($dragContainer, $dropContainer, groupName, dataSource, dropAction, contentSelector) {
    var self = this;
    $dragContainer.kendoDraggable({
      filter: '.' + listItemCssClass,
      group: groupName,
      container: self.$el,
      hint: function (element) {
        var $element = $(element);
        var hint = $element.find(contentSelector).eq(0).clone();
        $(hint).data('_uniqueId', $element.attr('data-id'));
        return hint;
      }
    });
    $dropContainer.kendoDropTarget({
      group: groupName,
      drop: function (e) {
        var item = dataSource.getItemData(e.draggable.hint.data()._uniqueId);
        if (item) {
          dropAction(item);
        }
      }
    });
  },
  _initializeEventHandlers: function () {
    var self = this;
    self.events = self.events || ({});
    var getEventHandler = function (dataSource, callback, eventType, eventName) {
      var proxy = _.bind(callback, this);
      return function (event) {
        var $itemelement = $(event.target).closest('.' + listItemCssClass);
        var item = dataSource.getItemData($itemelement.attr('data-id'));
        proxy(item);
        self.trigger(eventType, eventName, item);
      };
    };
    _.each(self.sourceActions, function (action, key) {
      self.events['click .sourceAction-' + key] = getEventHandler(self._viewModel.sourceData, action.callback, 'sourceItemAction', key);
    });
    _.each(self.selectedActions, function (action, key) {
      self.events['click .selectedAction-' + key] = getEventHandler(self._viewModel.selectedData, action.callback, 'selectedItemAction', key);
    });
  },
  _applyDefaultTemplates: function () {
    var self = this;
    self.options.templates = self.options.templates || ({});
    _.defaults(self.options.templates, defaultTemplates);
  },
  _initializeActions: function () {
    var self = this;
    self.sourceActions = {
      select: {
        callback: self.selectItem
      }
    };
    self.selectedActions = {
      deselect: {
        callback: self.deselectItem
      }
    };
    _.extend(self.sourceActions, self.options.itemActions.source || ({}));
    _.extend(self.selectedActions, self.options.itemActions.selected || ({}));
  },
  _initializeSourcePager: function () {
    var self = this;
    var pagerEl = self.$(self.options.templates.sourcePagerSelector);
    if (!pagerEl.length) {
      return;
    }
    var dataSource = self._viewModel.sourceDataSource;
    var pager = new Pager({
      el: pagerEl,
      pageSize: _.bind(dataSource.pageSize, dataSource),
      pageCount: _.bind(dataSource.totalPages, dataSource),
      currentPage: _.bind(dataSource.page, dataSource),
      enablePageJump: this.options.data.enablePageJump,
      refreshTriggers: [_.bind(dataSource.bind, dataSource, 'change')]
    });
    pager.currentPage.subscribe(function (newPage) {
      if (newPage && newPage !== dataSource.page()) {
        dataSource.page(newPage);
      }
    });
  },
  _initializeSelectedPager: function () {
    var self = this;
    var pagerEl = self.$(self.options.templates.selectedPagerSelector);
    if (!pagerEl.length) {
      return;
    }
    var dataSource = self._viewModel.selectedDataSource;
    var pager = new Pager({
      el: pagerEl,
      pageSize: _.bind(dataSource.pageSize, dataSource),
      totalCount: function () {
        return self._viewModel.selectedItems().length;
      },
      currentPage: _.bind(dataSource.page, dataSource),
      enablePageJump: this.options.data.enablePageJump,
      refreshTriggers: [_.bind(self._viewModel.selectedItems.subscribe, self._viewModel.selectedItems)]
    });
    pager.currentPage.subscribe(function (newPage) {
      if (newPage && newPage !== dataSource.page()) {
        if (dataSource.totalPages() === 0) {
          dataSource.page(newPage);
        }
        dataSource.page(newPage);
      }
    });
  }
});
export default controlView;

